import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { API, http, errorText } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await http.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("tdc_admin_token", data?.token || "");
      nav("/admin");
    } catch (e2) {
      setErr(errorText(e2, "Erro ao iniciar sessão."));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center px-5 grain" data-testid="admin-login-page">
      <form onSubmit={submit} className="glass-card w-full max-w-md p-10 space-y-6">
        <Logo className="h-12 w-12" />
        <div>
          <p className="eyebrow">Área reservada</p>
          <h1 className="font-display text-4xl text-[#F9F9F9] mt-2">Gestão de reservas</h1>
        </div>
        <input className="lux-input" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
        <input className="lux-input" type="password" placeholder="Palavra-passe" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
        {err && <p className="text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
        <button className="btn-gold w-full justify-center py-4" disabled={busy} data-testid="admin-login-submit">
          {busy ? <Loader2 size={16} className="animate-spin" /> : "Entrar"}
        </button>
        <Link to="/" className="block text-center text-xs uppercase tracking-[0.25em] text-zinc-400 hover:text-[#C5A059]" data-testid="admin-back-home">← Voltar ao site</Link>
      </form>
    </div>
  );
}
